export default {"src":"/uk/_next/static/media/state-street.9b1dc772.svg","height":158,"width":576,"blurWidth":0,"blurHeight":0};